<template>
  <v-flex
    style="
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    "
    class="pt-2"
  >
    <v-progress-circular
      v-if="spiner"
      :size="70"
      :width="7"
      color="purple"
      indeterminate
      style="height: 300px; padding-top: 5%"
    >
    </v-progress-circular>
    <v-flex v-for="courses_moun in this.cours" v-else>
      <span
        style="
          display: flex;
          justify-content: center;
          flex-direction: row;
          margin-bottom: 20px;
        "
      >
        <v-hover
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-around;
          "
        >
          <v-card
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 10 : 2}`"
            class=""
            width="280px"
            @click.prevent="courseDetail(courses_moun.mounted_curses.id)"
            style="cursor: pointer; border-radius: 10px"
          >
            <v-img
              class="white--text"
              height="150px"
              :src="courses_moun.mounted_curses.data.imageUrl"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox> </v-flex>
                </v-layout>
              </v-container>
            </v-img>
            <v-card-title>
              <div style="height: 30px">
                <span
                  class="subheading"
                  v-text="courses_moun.mounted_curses.name"
                ></span>
              </div>
            </v-card-title>

            <v-card-actions>
              <v-flex xs12 lg7 md7 class="text-center"> Mi progreso </v-flex>
              <v-flex xs12 lg5>
                <mini-progress
                  :id="courses_moun.mounted_curses.id"
                ></mini-progress>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-hover>
      </span>
    </v-flex>
  </v-flex>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import miniProgress from "./progress_mini.vue";
export default {
  name: "CoursesRegister",
  components: {
    miniProgress,
  },
  created() {
    this.getCourses();
  },
  data() {
    return {
      spiner: false,
    };
  },
  computed: {
    ...mapState,
    ...mapGetters({ cours: "course/allCourses" }),

    userId() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  methods: {
    getCourses: function () {
      this.spiner = true;
      this.$store
        .dispatch("course/getCourses")
        .then((response) => {
          this.spiner = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    courseDetail: function (courseId) {
      localStorage.setItem("mountedCourseId", courseId);
      this.$router.push("/home/course/in");
    },
  },
};
</script>